import { useTranslate } from "@refinedev/core";
import { Flex, theme, Typography } from "antd";
import { BooksIcon, FileVideoIcon } from "@phosphor-icons/react";
import { Card, Grid, Modal } from "@libertify/ui";

export type CreateExperienceChooserModalProps = {
  open: boolean;
  onClose: () => void;
  onChoosePlaybooks: () => void;
  onChooseLegacy: () => void;
};

/**
 * Chooser shown when starting a new experience: pick between the
 * new playbooks flow (/create-experience) and the legacy creation flow.
 */
export const CreateExperienceChooserModal = ({
  open,
  onClose,
  onChoosePlaybooks,
  onChooseLegacy,
}: CreateExperienceChooserModalProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="medium"
      title={t("createExperience.chooser.title")}
      showFooter={false}
    >
      <Flex vertical gap={16}>
        <Typography.Text type="secondary">
          {t("createExperience.chooser.subtitle")}
        </Typography.Text>
        <Grid columns={2} gap={12}>
          <Card hoverable onClick={onChoosePlaybooks}>
            <Flex vertical gap={10}>
              <BooksIcon size={24} color={token.colorPrimary} />
              <Typography.Text strong>
                {t("createExperience.chooser.playbooksTitle")}
              </Typography.Text>
              <Typography.Text type="secondary">
                {t("createExperience.chooser.playbooksDesc")}
              </Typography.Text>
            </Flex>
          </Card>
          <Card hoverable onClick={onChooseLegacy}>
            <Flex vertical gap={10}>
              <FileVideoIcon size={24} color={token.colorPrimary} />
              <Typography.Text strong>
                {t("createExperience.chooser.legacyTitle")}
              </Typography.Text>
              <Typography.Text type="secondary">
                {t("createExperience.chooser.legacyDesc")}
              </Typography.Text>
            </Flex>
          </Card>
        </Grid>
      </Flex>
    </Modal>
  );
};
